import { render, staticRenderFns } from "./ArmazemModal.vue?vue&type=template&id=0ce00c44&scoped=true"
import script from "./ArmazemModal.vue?vue&type=script&lang=js"
export * from "./ArmazemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce00c44",
  null
  
)

export default component.exports